import { type ProductData } from "../../../../models/ProductData";
import { DownloadUrlLink, getDownloadProperty } from "../../../../common/components/Link";
import { trackRohsDownloadDatasheet } from "../../../../feature/Analytics/ga/ga";
import { useTranslation } from "react-i18next";

interface PdfDownloadLinkProps {
  product: Pick<ProductData, "code" | "designation">;
}

const PdfDownloadLink = ({ product }: PdfDownloadLinkProps) => {
  const { t } = useTranslation();

  let timezone;
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    timezone = "UTC";
  }

  const url = `/p/rohs/${product.code}?timezone=${timezone}`;
  const label = t("productDetailPage.downloadRohsPdf");

  return (
    <DownloadUrlLink
      download={getDownloadProperty(`${product.designation}.pdf`)}
      href={url}
      className={"scha__pdp__pdf-link"}
      onClick={() => trackRohsDownloadDatasheet(product.designation)}
    >
      {label}
    </DownloadUrlLink>
  );
};

export default PdfDownloadLink;
